import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

export const schoolcolumns = [
  key('学校确认单ID', 'sheetId', tableColumnsWidth.type4, {
    fixed: 'left'
  }),
  slot('学校', 'schoolName', tableColumnsWidth.type6, {
    fixed: 'left'
  }),
  key('学期', 'yearTerm', 180, {
    fixed: 'left'
  }),
  slot('月份', 'beginDate', 100, {
    fixed: 'left'
  }),
  key('本月出勤人数', 'teacherNum', 130, {
    fixed: 'left'
  }),
  key('本月出勤总数', 'signNum', 130),
  key('合计金额（元）', 'totalAmt', tableColumnsWidth.type3),
  key('实发金额（元）', 'realAmt', tableColumnsWidth.type3),
  slot('确认单状态', 'sheetSts', 130),
  slot('结算状态', 'settleSts', 130),
  key('生成时间', 'createTime', tableColumnsWidth.type5),
  key('结算时间', 'settleTime', tableColumnsWidth.type5),
  key('教师课酬方案', 'planName', tableColumnsWidth.type7),
  key('提示', 'remark', tableColumnsWidth.type6),
  slot('操作', 'action', tableColumnsWidth.default, {
    fixed: 'right'
  })
]

export const teachercolumns = [
  key('教师确认单ID', 'itemId', tableColumnsWidth.type4, {
    fixed: 'left'
  }),
  key('教师姓名', 'userName', 100, {
    fixed: 'left'
  }),
  slot('学校', 'schoolName', tableColumnsWidth.type6, {
    fixed: 'left'
  }),
  key('教师手机号码', 'phoneNo', 130, {
    fixed: 'left'
  }),
  slot('月份', 'beginDate', tableColumnsWidth.type2),
  key('本月出勤总数', 'signNum', 130),
  key('应结算金额（元）', 'payableAmt', tableColumnsWidth.type3),
  slot('补发/补扣金额（元）', 'supplementalAmt', tableColumnsWidth.type4),
  // {
  //   renderHeader: (h, params) => {
  //     const handleClickMerge = () => {
  //       console.log(this)
  //     }
  //     return h(
  //       'div',
  //       {
  //         on: {
  //           click: handleClickMerge
  //         }
  //       },
  //       [
  //         h('span', '合计金额（元）'), //列名
  //         h('Icon', { props: { type: 'ios-build', class: 'cursor-pointer' } }) // 问号图标
  //       ]
  //     )
  //   },
  //   key: 'totalAmt',
  //   width: tableColumnsWidth.type3
  // },
  key('合计金额（元）', 'totalAmt', tableColumnsWidth.type3),
  key('本月实缴个税（元）', 'taxAmt', 170),
  key('实发金额（元）', 'realAmt', tableColumnsWidth.type3),
  key('补发/补扣说明', 'supplementalMsg', tableColumnsWidth.type3),

  slot('确认单状态', 'itemSts', 110),
  slot('结算状态', 'settleSts', 100),
  key('生成时间', 'createTime', 170),
  key('更新时间', 'operateTime', 170),
  slot('操作', 'action', tableColumnsWidth.default, {
    fixed: 'right'
  })
]

export const recordsColumns = [
  key('操作类型', 'actTypeName', tableColumnsWidth.type3),
  key('确认单ID', 'itemId', tableColumnsWidth.type4),
  key('操作人', 'creatorName', tableColumnsWidth.type2),
  key('操作时间', 'createTime', tableColumnsWidth.type4),
  key('说明', 'actDesc', 350)
]

//确认单状态 -学校
export const schList = [
  { id: 0, name: '待运营确认' },
  { id: 2, name: '待学校确认' },
  { id: 3, name: '待财务确认' },
  { id: 4, name: '财务确认驳回' },
  { id: 1, name: '已对账' }
]

//确认单状态 -教师
export const teaList = [
  { id: 0, name: '待确认' },
  { id: 1, name: '已确认' },
  { id: 2, name: '已取消' }
]

//结算状态
export const settleList = [
  { id: 1, name: '已结算' },
  { id: 0, name: '待结算' },
  { id: 2, name: '结算中' }
]
//操作记录
export const columns = [
  key('操作类型', 'bankName', tableColumnsWidth.type4),
  key('操作人', 'relProdNum', tableColumnsWidth.type3),
  key('操作时间', 'relProdNum', tableColumnsWidth.type4),
  key('说明', 'relProdNum', tableColumnsWidth.type7)
]

//失败明细
export const failColumns = [
  {
    type: 'index',
    width: 60,
    align: 'center'
  },
  key('教师姓名', 'userName', tableColumnsWidth.type3),
  key('教师手机号码', 'phoneNo', tableColumnsWidth.type4),
  key('原因/说明', 'checkDesc', tableColumnsWidth.type7)
]
